<template>
  <div class='monthCalendar'>
    <full-calendar ref='calendar' @event-selected='eventSelected' @event-created='eventCreated' :config='config' :header='header' :event-sources="eventSources"></full-calendar>
  </div>
</template>

<script>

import '../../../../static/css/fullCalendarPc.styl'
import moment from 'moment'
import {mapState} from 'vuex'
import axios from 'axios'

export default {
  name: 'Calendar',
  components: {
  },
  data: function () {
    let _this = this
    return {
      type: {
        method: '',
        task_no: ''
      },
      addScheduleDialogVisible: false,
      eventSources: [
        {
          events: function (start, end, timezone, callback) {
            let startTime = moment(start._d).format('YYYY-MM-DD')
            let endTime = moment(end._d).format('YYYY-MM-DD')
            console.log(startTime, endTime)
            axios({
              method: 'get',
              url: _this.HOST + '/task/getAllTask',
              params: {
                user_no: _this.$store.state.userInfo.user_no,
                start: startTime,
                end: endTime
              }
            }).then(function (response) {
              let data = response.data
              console.log('所有的日程')
              console.log(data)
              if (data.length === 0) {
                console.log('所有的日程为空')
              } else {
                callback(data)
              }
            }).catch(function (error) {
              console.log(error)
            })
          }
        }
      ],
      config: {
        height: window.innerHeight,
        defaultView: 'month',
        theme: false,
        firstDay: 1,
        dayNamesShort: ['日', '一', '二', '三', '四', '五', '六'],
        buttonText: {
          today: '今天',
          month: '月',
          week: '周',
          day: '天',
          listMonth: '列表'
        },
        allDayDefault: false,
        slotLabelFormat: 'H',
        businessHours: {
          dow: [1, 2, 3, 4, 5],
          start: '9:00',
          end: '19:00'
        },
        allDaySlot: true,
        allDayText: '全天',
        timeFormat: 'HH:mm', // 设置的是添加的具体的日程上显示的时间
        views: {
          month: {
            titleFormat: 'YYYY年M月'
          },
          week: {
            titleFormat: 'YYYY年M月D日',
            columnFormat: 'M.D dddd'
          },
          day: {
            titleFormat: 'YYYY年M月D日 dddd',
            columnFormat: 'M/D dddd'
          }
        }
      },
      header: {
        left: '',
        right: '',
        center: 'prev,title,next'
      }
    }
  },
  computed: {
    ...mapState([
      'allScheduleList',
      'calanderRefresh'
    ])
  },
  methods: {
    eventSelected (event) {
      console.log('事件选中')
      console.log(event)
      let data = {
        visible: true,
        method: 'edit',
        no: event.task_no
      }
      this.$store.dispatch('setScheduleDialog', data)
    },
    eventCreated (selected) {
      console.log('事件创建')
      console.log(selected)
      this.$store.dispatch('setSelectDate', moment(selected.start._d).format('YYYY-MM-DD'))
      this.$store.dispatch('setTodayScheduleList')
      // let data = {
      //   visible: true,
      //   method: 'add',
      //   no: ''
      // }
      // this.$store.dispatch('setScheduleDialog', data)
    },
    closeDialog () {
      this.addScheduleDialogVisible = false
    },
    refreshEvents () {
      console.log('refreshEvents')
      this.$refs.calendar.$emit('refetch-events')
    }
  },
  watch: {
    calanderRefresh: function (newVal, oldVal) {
      if (newVal) {
        this.refreshEvents()
        this.$store.dispatch('setCalanderRefresh', false)
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.monthCalendar
  position absolute
  top 0
  left 21.5rem
  bottom 0
  right 0
</style>



// WEBPACK FOOTER //
// src/pagesPc/main/component/monthCalendar.vue